import utils from '@/tools/utils';

export default {
  computed: {
    bizTypes: function () {
      let bizTypes = this.$getDict('bspBizType') || [];
      return bizTypes.filter(f => {
        return this.type === 0 ? f.key.startsWith('1') : (f.key.startsWith('2') || f.key.startsWith('3'));
      });
    },
    type() {
      return this.$route.meta.type;
    },
    isInOrder () { // 入库订单
      return this.type === 0;
    },
    role () {
      return this.$route.meta.role;
    },
    isPlatForm () {
      return this.role === 'platform'
    }
  },
  methods: {
    /**
     * 重置url为默认路径 urlAry 是默认路径用/分隔最后一个字符串的集合，用来判断是否默认路径
     * @param urlAry
     */
    resetUrl (urlAry) {
      if (!(urlAry instanceof Array)) return;
      let path = this.$route.path;
      let ary = path.split('/');
      let str = ary.length && ary[ary.length - 1] || '';
      if (!urlAry.includes(str)) {
        // 不是默认路径, 取默认路径
        ary.pop();
        this.$router.push(ary.join('/'));
      } else {
        this.$router.push(path);
      }
    },
    serUrl() {

    },
    checkHasOrderNotAdded (product) {
      if (product.orgGoodsId) {
        this.$notify({
          duration: 2000,
          message: '存在货品未加入订单，请加入',
          type: 'warning'
        });
        return false;
      }
      return true;
    },
    changeTotalNumber: utils.changeTotalNumber,
    isCheckPackage: utils.isCheckPackage
  }
};

